module.exports = __webpack_public_path__ + "static/media/Depression.d22747bd.svg";